/* eslint-disable @typescript-eslint/naming-convention */
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';

import { BuildingDto, ExportBuildingAsset } from '../models';

const HEADER = [
  [
    'COD EDIFICIO',
    'Dirección',
    'CP',
    'Localidad',
    'Escalera',
    'Portal',
    'Planta',
    'Letra',
    'Renta pactada',
    'PRIMA',
    'PÓLIZA',
    'Fecha de inicio',
    'Estado',
    'DNI/NIE Inquilinos'
  ]
];

const HEADER_TO_KEY_MAPPING = {
  'COD EDIFICIO': 'homeownerReference',
  Dirección: 'address',
  CP: 'postalCode',
  Localidad: 'town',
  Escalera: 'stairs',
  Portal: 'portal',
  Planta: 'floor',
  Letra: 'door',
  'Renta pactada': 'rentalPrice',
  PRIMA: 'premium',
  PÓLIZA: 'policyNumber',
  'Fecha de inicio': 'inceptionDate',
  Estado: 'status',
  'DNI/NIE Inquilinos': 'tenantsDNI'
};

export function exportToXlsx(
  data: ExportBuildingAsset[],
  building: BuildingDto
): void {
  const name = building.number
    ? `${building.street} ${building.number}.xlsx`
    : `${building.street}.xlsx`;

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Edificio');

  worksheet.columns = HEADER[0].map((header: string) => ({
    header,
    key: HEADER_TO_KEY_MAPPING[header],
    width: 20 // Set width according to your requirement
  }));

  // Map data to rows
  data.forEach((item: ExportBuildingAsset) => {
    const row = {};
    HEADER[0].forEach((header: string) => {
      row[HEADER_TO_KEY_MAPPING[header]] = item[HEADER_TO_KEY_MAPPING[header]];
    });
    worksheet.addRow(row);
  });

  workbook.xlsx.writeBuffer().then((data) => {
    const blobType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const blob = new Blob([data], { type: blobType });
    FileSaver.saveAs(blob, name);
  });
}
